
























import Vue from "vue";
export default Vue.extend({
	name: "Button",
	props: {
		href: {
			default: false,
			type: [Boolean, String],
		},
		md: {
			default: false,
			type: [Boolean, String],
		},
		download: Boolean,
		animate: Boolean,
		outlined: Boolean,
	},
});
